import React from 'react'
import Head from "next/head";
import HUL from '@/components/casestudy/HUL';

const hul = () => {
    return (
        <>
            <Head>
                <title>HUL Case Study: Revolutionizing Retail Operations with QB</title>
                <link rel="canonical" href="https://queuebuster.co/casestudy/hul" />
                <link rel="alternate" href="https://queuebuster.co/casestudy/hul" hrefLang="en-us" />
                <meta name="description" content="Discover how Hindustan Unilever Limited optimized its retail operations using QueueBuster POS. Learn about their success in improving efficiency, reducing costs" />
                <meta property="og:title" content="HUL's Success Story with QueueBuster POS: Transforming Retail Operations" />
                <meta property="og:description" content="Explore how Hindustan Unilever Limited (HUL) leveraged QueueBuster POS to streamline their retail operations, boost efficiency, and deliver a superior customer experience. Learn about the innovative solutions that powered their success." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/gradient.png" />
                <meta property="og:url" content="https://queuebuster.co/casestudy/hul" />
            </Head>
            <HUL />
        </>
    )
}

export default hul